import React, { useState } from "react";
import { RaidIntroView } from "@/views/raid/raid-intro-view";
import { useSPAContext } from "@/providers/spa-provider";
import { RouteNames } from "@/types/route-names";

export const DevRaidIntroView: React.FC = () => {
  const { setCurrentRoute } = useSPAContext();
  const [key, setKey] = useState(0); // Used to force remount/replay
  const [raidName, setRaidName] = useState("default");

  const handleComplete = () => {
    console.log("Intro sequence completed!");
  };

  const handleReplay = () => {
    setKey((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentRoute(RouteNames.PLAY_MENU);
  };

  return (
    <div className="relative w-full h-full bg-black">
      <div className="absolute inset-0">
        <RaidIntroView
          key={key}
          raidName={raidName}
          onComplete={handleComplete}
        />
      </div>

      {/* Dev Controls Overlay */}
      <div className="absolute top-4 left-4 z-[999999] flex flex-col gap-2 bg-black/50 p-2 rounded pointer-events-auto">
        <h2 className="text-white font-bold text-sm">Dev Controls</h2>
        
        <div className="flex gap-2">
          <button
            onClick={handleBack}
            className="px-3 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700"
          >
            Exit
          </button>
          <button
            onClick={handleReplay}
            className="px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
          >
            Replay
          </button>
        </div>

        <div className="flex flex-col gap-1 mt-2">
            <label className="text-white text-xs">Raid Name:</label>
            <select 
                value={raidName} 
                onChange={(e) => {
                    setRaidName(e.target.value);
                    setKey(k => k + 1);
                }}
                className="bg-gray-800 text-white text-xs p-1 rounded border border-gray-600"
            >
                <option value="default">Default (Test)</option>
                <option value="Forest Guardian">Forest Guardian</option>
            </select>
        </div>
      </div>
    </div>
  );
};

